import Moment from 'moment';
import { GetClientes, GetEmbarquesSerialesID, GetPProduccionGeneral, GetPProduccionGeneralID, GetPProduccionID, GetPlaneacionBaseGeneral, GetPlaneacionBaseGeneralID, GetPlaneacionBaseID, GetPlaneacionID, GetProductos, GetRecibaSerialesID, GetRecibaSerialesMP } from './Queries';

//Función que decodific a las ubicaciones
export async function ObtenerUbicaciones(ubicacion) {
  var aUbicaciones = [];
  ubicacion.map((x) => {
    const ubicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', '');
    const locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', '');
    const cantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', '');
    const espacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search(',') - 1).replace('espacio=', '');
    const comentarios = x.substr(x.search('comentarios=') + 11, x.length).substr(1, x.substr(x.search('comentarios=') + 11, x.length).search(',') - 1).replace('comentarios=', '');
    const ubicaciondeReciba = x.substr(x.search('ubicaciondeReciba=') + 17, x.length).substr(1, x.substr(x.search('ubicaciondeReciba=') + 17, x.length).search(',') - 1).replace('ubicaciondeReciba=', '');
    const activo = x.substr(x.search('activo=') + 6, x.length).substr(1, x.substr(x.search('activo=') + 6, x.length).search(',') - 1).replace('activo=', '');
    const orden = x.substr(x.search('orden=') + 5, x.length).substr(1, x.substr(x.search('orden=') + 5, x.length).search(',') - 1).replace('orden=', '');
    const fechaIngreso = x.substr(x.search('fechaIngreso=') + 12, x.length).substr(1, x.substr(x.search('fechaIngreso=') + 12, x.length).search(',') - 1).replace('fechaIngreso=', '');
    const horaIngreso = x.substr(x.search('horaIngreso=') + 11, x.length).substr(1, x.substr(x.search('horaIngreso=') + 11, x.length).search(',') - 1).replace('horaIngreso=', '');
    const ultimo = x.substr(x.search('ultimo=') + 6, x.length).substr(1, x.substr(x.search('ultimo=') + 6, x.length).search(',') - 1).replace('ultimo=', '');
    const ultimoAnterior = x.substr(x.search('ultimoAnterior=') + 14, x.length).substr(1, x.substr(x.search('ultimoAnterior=') + 14, x.length).search(',') - 1).replace('ultimoAnterior=', '');
    const fechaSalida = x.substr(x.search('fechaSalida=') + 11, x.length).substr(1, x.substr(x.search('fechaSalida=') + 11, x.length).search(',') - 1).replace('fechaSalida=', '');
    const horaSalida = x.substr(x.search('horaSalida=') + 10, x.length).substr(1, x.substr(x.search('horaSalida=') + 10, x.length).search('}') - 1).replace('horaSalida=', '');

    aUbicaciones.push({
      ubicacion: ubicacion,
      locacion: locacion,
      cantidad: parseInt(cantidad),
      espacio: parseInt(espacio),
      comentarios: comentarios,
      ubicaciondeReciba: ubicaciondeReciba === "true" ? true : false,
      activo: activo === "true" ? true : false,
      orden: parseInt(orden),
      fechaIngreso: fechaIngreso,
      horaIngreso: horaIngreso,
      ultimo: ultimo === "true" ? true : false,
      ultimoAnterior: parseInt(ultimoAnterior),
      fechaSalida: fechaSalida,
      horaSalida: horaSalida,
    })

  })
  return aUbicaciones;
}

//Función que decodific a las ubicaciones
export async function decodificarTextoJSON(textoJ) {
  var decodJ = [];
  textoJ.map((x) => {
    const textodecod = deTextoaJson(x);
    decodJ.push(textodecod);
  })
  return decodJ;
}

export function obtenerUltimaUbicacionA(ubicacion) {
  var aUbicaciones = [];
  ubicacion.map((x) => {
    const ubicacion = x.substr(1, x.search(',') - 1).replace('ubicacion=', '');
    const locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', '');
    const cantidad = x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', '');
    const espacio = x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search(',') - 1).replace('espacio=', '');
    const comentarios = x.substr(x.search('comentarios=') + 11, x.length).substr(1, x.substr(x.search('comentarios=') + 11, x.length).search(',') - 1).replace('comentarios=', '');
    const ubicaciondeReciba = x.substr(x.search('ubicaciondeReciba=') + 17, x.length).substr(1, x.substr(x.search('ubicaciondeReciba=') + 17, x.length).search(',') - 1).replace('ubicaciondeReciba=', '');
    const activo = x.substr(x.search('activo=') + 6, x.length).substr(1, x.substr(x.search('activo=') + 6, x.length).search(',') - 1).replace('activo=', '');
    const orden = x.substr(x.search('orden=') + 5, x.length).substr(1, x.substr(x.search('orden=') + 5, x.length).search(',') - 1).replace('orden=', '');
    const fechaIngreso = x.substr(x.search('fechaIngreso=') + 12, x.length).substr(1, x.substr(x.search('fechaIngreso=') + 12, x.length).search(',') - 1).replace('fechaIngreso=', '');
    const horaIngreso = x.substr(x.search('horaIngreso=') + 11, x.length).substr(1, x.substr(x.search('horaIngreso=') + 11, x.length).search(',') - 1).replace('horaIngreso=', '');
    const ultimo = x.substr(x.search('ultimo=') + 6, x.length).substr(1, x.substr(x.search('ultimo=') + 6, x.length).search(',') - 1).replace('ultimo=', '');
    const ultimoAnterior = x.substr(x.search('ultimoAnterior=') + 14, x.length).substr(1, x.substr(x.search('ultimoAnterior=') + 14, x.length).search(',') - 1).replace('ultimoAnterior=', '');
    const fechaSalida = x.substr(x.search('fechaSalida=') + 11, x.length).substr(1, x.substr(x.search('fechaSalida=') + 11, x.length).search(',') - 1).replace('fechaSalida=', '');
    const horaSalida = x.substr(x.search('horaSalida=') + 10, x.length).substr(1, x.substr(x.search('horaSalida=') + 10, x.length).search('}') - 1).replace('horaSalida=', '');
    aUbicaciones.push({
      ubicacion: ubicacion,
      locacion: locacion,
      cantidad: cantidad,
      espacio: espacio,
      comentarios: comentarios,
      ubicaciondeReciba: ubicaciondeReciba,
      activo: activo,
      espacio: espacio,
      orden: orden,
      fechaIngreso: fechaIngreso,
      horaIngreso: horaIngreso,
      ultimo: ultimo,
      ultimoAnterior: ultimoAnterior,
      fechaSalida: fechaSalida,
      horaSalida: horaSalida,
    })

  })
  return aUbicaciones;
}
//Función que decodifica los serialesID
export async function ObtenerSeriales(serialesIDs) {
  var serialesID = [];
  await Promise.all(serialesIDs.map(async (x) => {
    const serialID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const seriales = await GetRecibaSerialesID(serialID);
    serialesID.push(seriales)
    /*serialesID.push({
      id: serialID,
    })*/
    return x;
  }))
  return serialesID;
}
export async function cambioUbicacionSeriales(recibaSeriales, ubicacionAnterior, loacionAnterior, ubicacionDestino, locacionDestino, cantidadPiezas, json) {
  var resultado = { mensaje: "", color: "primary", deshabilitarBoton: true, completo: false, sUltimaU: [], sUbicaciones: [] };
  //Se obtienen los datos de ubicación del material que se cambiará de ubicación.
  var ubicacionSinfiltro = json === true ? recibaSeriales.rubicaciones : await ObtenerUbicaciones(recibaSeriales.rubicaciones);
  //Si no se obtuvieron ubicaciones, se termina el proceso
  var ubicacionSinfiltro = ubicacionSinfiltro.sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
  if (!ubicacionSinfiltro[0]) {
    resultado.mensaje = "Operación errónea, no existen ubicaciones del registro actual para cambiar la ubicación del material.";
    resultado.color = "warning";
    return resultado;
  }
  const ubicacionFromAPI = ubicacionSinfiltro.filter((ubicacion) =>
    (!ubicacion.fechaSalida || ubicacion.fechaSalida === "") &&
    ubicacion.activo === true && ubicacion.ubicacion === ubicacionAnterior &&
    ubicacion.locacion === loacionAnterior).sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0));
  if (!ubicacionFromAPI[0]) {
    resultado.mensaje = "Operación errónea, no existen ubicaciones del registro actual en " + loacionAnterior +
      " sin fecha de salida registrada, para cambiar la ubicación del material.";
    resultado.color = "warning";
    return resultado;
  }

  //Datos requeridos para registrar la operación
  const fechaSalida = Moment(new Date()).format("YYYY-MM-DD");
  const horaSalida = Moment(new Date()).format("HH:mm");

  var PiezasUbicacion = cantidadPiezas;
  //setMensajeAlert("Obteniebdo datos");
  var ubicacionesm = [];
  var ubicacionesS = [];
  var orden = ubicacionSinfiltro.length + 1;
  var ultimoAnterior = ubicacionSinfiltro.length;
  await Promise.all(ubicacionSinfiltro.map(async (ubicacion, i) => {
    //Si se encuentran registros de la ubicación y locación anterior, se guarda un registro en ubicacionesS
    ultimoAnterior = ubicacion.orden;
    if ((!ubicacion.fechaSalida || ubicacion.fechaSalida === "") &&
      ubicacion.activo === true && ubicacion.ubicacion === ubicacionAnterior &&
      ubicacion.locacion === loacionAnterior) {
      if (PiezasUbicacion > 0) {
        ubicacionesm.push(ubicacion);
        //Se indica fecha y hora de salida al registro en Inspección que corresonde en Producción.
        const cantidadOriginal = ubicacion.cantidad;
        ubicacion.fechaSalida = fechaSalida;
        ubicacion.horaSalida = horaSalida;
        ubicacion.ultimo = false;
        ubicacion.cantidad = cantidadOriginal > PiezasUbicacion ? PiezasUbicacion : cantidadOriginal;
        ubicacionesS.push(ubicacion);
        //Si la cantidad de las piezas en la ubicación anterior es mayor a las piezas a reubicar,
        //Se agrega un registro en ubicacionesS con la cantidad que corresponde que debería quedar en la nueva ubicación.
        if (cantidadOriginal > PiezasUbicacion) {
          //Se agrega un nuevo registro de ubicación en la ubicación anterior.   
          const rsubicacion = {
            ...ubicacion,
            ultimo: false,
            ultimoAnterior: ultimoAnterior,
            orden: orden,
            cantidad: cantidadOriginal - PiezasUbicacion,
            fechaSalida: "",
            horaSalida: ""
          };
          //Agregado a ubicacionesS
          ubicacionesS.push(rsubicacion);

          ultimoAnterior = orden;
          orden++;
          PiezasUbicacion = 0;
        } else {
          PiezasUbicacion = PiezasUbicacion - cantidadOriginal;
        }
        // orden++;
        /*------------------------------ */
      } else {
        //Agregado a ubicacionesS
        ubicacionesS.push(ubicacion);
      }
    } else {
      //Se guardan el resto de la ubicaciones en ubicacionesS
      ubicacionesS.push(ubicacion);
    }
  })
  );

  //Se agrega un nuevo registro de ubicación en la ubicación que corresponde.
  const ubicacion = {
    ...ubicacionesm[0],
    fechaIngreso: fechaSalida,
    horaIngreso: horaSalida,
    ubicacion: ubicacionDestino,
    locacion: locacionDestino,
    ubicaciondeReciba: false,
    ultimo: true,
    fechaSalida: "",
    horaSalida: "",
    ultimoAnterior: ultimoAnterior,
    orden: orden,
    espacio: 0,
    cantidad: cantidadPiezas
  };

  //Agregado a ubicacionesS
  ubicacionesS.push(ubicacion);

  //Se agrupan las ubicaciones de última ubicación
  const sUltimaU = ubicacionesS.filter((ubicacion) =>
    ubicacion.fechaSalida === "" && ubicacion.activo === true).sort((a, b) =>
      a.ubicacion + (a.locacion ? a.locacion : "") >
        b.ubicacion + (b.locacion ? b.locacion : "")
        ? 1
        : a.ubicacion + (a.locacion ? a.locacion : "") <
          b.ubicacion + (b.locacion ? b.locacion : "")
          ? -1
          : 0
    );
  //Se obtienen los datos de última ubicación
  var auxUltimaUbicacion = [];
  var ubicacionLocacionanterior =
    (sUltimaU[0].ubicacion ? sUltimaU[0].ubicacion : "") +
    (sUltimaU[0].locacion ? sUltimaU[0].locacion : "");
  var cantidadTotal = 0;
  var espacio = 0;
  await Promise.all(
    sUltimaU.map(async (ubicacion, i) => {
      const ubicacionLocacion =
        (ubicacion.ubicacion ? ubicacion.ubicacion : "") +
        (ubicacion.locacion ? ubicacion.locacion : "");
      if (ubicacionLocacion !== ubicacionLocacionanterior) {
        auxUltimaUbicacion.push({
          ubicacion: sUltimaU[i - 1].ubicacion,
          locacion: sUltimaU[i - 1].locacion,
          cantidad: cantidadTotal,
          espacio: espacio,
        });
        ubicacionLocacionanterior = ubicacionLocacion;
        cantidadTotal = 0;
        espacio = 0;
      }
      cantidadTotal = parseInt(cantidadTotal) + parseInt(ubicacion.cantidad ? ubicacion.cantidad : 0);
      espacio = espacio + ubicacion.espacio;

      if (i === sUltimaU.length - 1) {
        auxUltimaUbicacion.push({
          ubicacion: ubicacion.ubicacion,
          locacion: ubicacion.locacion,
          cantidad: cantidadTotal,
          espacio: espacio,
        });
      }
    })
  );
  resultado.sUltimaU = auxUltimaUbicacion;
  resultado.sUbicaciones = ubicacionesS;
  return resultado
}
//Función que decodifica los seriales de una planeación
export async function ObtenerSerialesPlaneacion(planeacionIDs) {
  var planeacionesID = [];
  await Promise.all(planeacionIDs.map(async (x) => {
    const planeacionID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const seriales = await GetPlaneacionID(planeacionID);
    planeacionesID.push(seriales)
    /*planeacionesID.push({
      id: planeacionID,
    })*/
    return x;
  }))
  return planeacionesID;
}
//Función que decodifica los seriales de una planeación
export async function ObtenerSerialesPlaneacionBase(planeacionIDs) {
  var planeacionesID = [];
  var racks = 0;
  var ciclos = 0;
  var costoTotalP = 0;
  var costoTotalD = 0;
  var costoTotalE = 0;
  await Promise.all(planeacionIDs.map(async (x) => {
    const planeacionID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const seriales = await GetPlaneacionBaseID(planeacionID);
    if (seriales.id) {
      racks += parseFloat(seriales.racks);
      ciclos += parseFloat(seriales.ciclos);
      if (seriales.divisa === "Dólar")
        costoTotalD += (seriales.Ecoat === true ? parseFloat((seriales.precioUnitario ? seriales.precioUnitario : 0) * seriales.cantidadPiezas) : 0) +
          (seriales.Pcoat === true ? parseFloat((seriales.precioUnitarioPC ? seriales.precioUnitarioPC : 0) * seriales.cantidadPiezas) : 0)/* +
          (seriales.Platinado === true ? parseFloat((seriales.precioUnitarioP ? seriales.precioUnitarioP : 0) * seriales.cantidadPiezas) : 0)*/;
      if (seriales.divisa === "Euro")
        costoTotalE += (seriales.Ecoat === true ? parseFloat((seriales.precioUnitario ? seriales.precioUnitario : 0) * seriales.cantidadPiezas) : 0) +
          (seriales.Pcoat === true ? parseFloat((seriales.precioUnitarioPC ? seriales.precioUnitarioPC : 0) * seriales.cantidadPiezas) : 0) /*+
          (seriales.Platinado === true ? parseFloat((seriales.precioUnitarioP ? seriales.precioUnitarioP : 0) * seriales.cantidadPiezas) : 0)*/;
      if (seriales.divisa === "Peso mexicano")
        costoTotalP += (seriales.Ecoat === true ? parseFloat((seriales.precioUnitario ? seriales.precioUnitario : 0) * seriales.cantidadPiezas) : 0) +
          (seriales.Pcoat === true ? parseFloat((seriales.precioUnitarioPC ? seriales.precioUnitarioPC : 0) * seriales.cantidadPiezas) : 0) /*+
          (seriales.Platinado === true ? parseFloat((seriales.precioUnitarioP ? seriales.precioUnitarioP : 0) * seriales.cantidadPiezas) : 0)*/;
    }
    planeacionesID.push(seriales)
    /*planeacionesID.push({
      id: planeacionID,
    })*/
    return x;
  }))
  return {
    planeacionBase: planeacionesID, racks: racks, ciclos: ciclos, costoTotalD: costoTotalD,
    costoTotalE: costoTotalE, costoTotalP: costoTotalP
  };
}
//Función que decodifica los seriales de un plan producción
export async function ObtenerSerialesPProduccion(pproduccion, hora) {
  var pproduccionIDsg = [];
  var totalInspeccionadoPG = 0;
  var totalInspeccionadoPGPC = 0;
  const pPorSerial = pproduccion.porSerial ? pproduccion.porSerial : false;
  const pproduccionDatos = await ObtenerSerialesPProduccionPS(pproduccion);
  await Promise.all(pproduccionDatos.map(async (seriales) => {
    /*const pproduccionID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const seriales = pPorSerial === true ?
      await GetRecibaSerialesID(pproduccionID) : await GetPProduccionID(pproduccionID);*/

    if (seriales.activo === true) {
      if ((pPorSerial === true && ((seriales.cargaFechaHora ? seriales.cargaFechaHora : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.pintadoFechaHora ? seriales.pintadoFechaHora : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.calidadFechaHora ? seriales.calidadFechaHora : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.cargaFechaHoraPC ? seriales.cargaFechaHoraPC : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.pintadoFechaHoraPC ? seriales.pintadoFechaHoraPC : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.calidadFechaHoraPC ? seriales.calidadFechaHoraPC : "").includes(pproduccion.fechaDePlaneacion) ||
        (seriales.noAceptadasFechaHora ? seriales.noAceptadasFechaHora : "").includes(pproduccion.fechaDePlaneacion)))) {

        //Se obtienen los datos de carga que corresponden al plan de producción indicado
        var sumCargaPA = 0;
        var empaquesCarga = 0;
        var RacksCarga = "";
        var sumRacksCarga = 0;
        var sumCiclosCarga = 0;
        const datosCargaF = seriales.registroCarga ? await seriales.registroCarga.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : [];
        if (datosCargaF.length > 0) {
          const datosCarga = await ObtenerDCargaPProduccion(datosCargaF);
          await Promise.all(datosCarga.map(async (carga) => {
            RacksCarga = RacksCarga === "" ? carga.numeroRackCarga : RacksCarga + ", " + carga.numeroRackCarga;
            if (carga.fecha === pproduccion.fechaDePlaneacion && carga.hora <= ((hora ? hora : "") != "" ? hora : carga.hora)) {
              sumCargaPA += parseInt(carga.piezasenCarga ? carga.piezasenCarga : 0);
              empaquesCarga += parseInt(carga.materialEnCantidad ? carga.materialEnCantidad : 0);
              sumRacksCarga += parseFloat(carga.racks ? carga.racks : 0);
              sumCiclosCarga += parseInt(carga.ciclos ? carga.ciclos : 0);
            }
            return carga;
          }))
        }
        //Se obtienen los datos de pintado que corresponden al plan de producción indicado
        var sumPintadoPA = 0;
        const datosPintadoF = seriales.registroPintado ? await seriales.registroPintado.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : []
        if (datosPintadoF.length > 0) {
          const datosPintado = await ObtenerDPintadoPProduccion(datosPintadoF);
          await Promise.all(datosPintado.map(async (pintado) => {
            if (pintado.fecha === pproduccion.fechaDePlaneacion && pintado.hora <= ((hora ? hora : "") != "" ? hora : pintado.hora)) {
              sumPintadoPA = sumPintadoPA + pintado.piezasenPintado;
            }
            return pintado;
          }))
        }
        //Se obtienen los datos de inspección final que corresponden al plan de producción indicado
        var sumInspeccionFPA = 0;
        var sumInspeccionFPNA = 0;
        const datosInspeccionF = seriales.registroInspeccionF ? await seriales.registroInspeccionF.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : [];
        if (datosInspeccionF.length > 0) {
          const datosInspeccion = await ObtenerDInspeccionFPProduccion(datosInspeccionF);
          await Promise.all(datosInspeccion.map(async (inspeccion) => {
            if (inspeccion.fecha === pproduccion.fechaDePlaneacion && inspeccion.hora <= ((hora ? hora : "") != "" ? hora : inspeccion.hora)) {
              sumInspeccionFPA = sumInspeccionFPA + parseInt(inspeccion.piezasAceptadas ? inspeccion.piezasAceptadas : 0);
              sumInspeccionFPNA = sumInspeccionFPNA + parseInt(inspeccion.piezasNoAceptadas ? inspeccion.piezasNoAceptadas : 0);
            }
            return inspeccion;
          }))
        }
        /**********************************************************************************/
        //Se obtienen los datos de carga que corresponden al plan de producción indicado
        var sumCargaPAPC = 0;
        var empaquesCargaPC = 0;
        var sumRacksCargaPC = 0;
        var sumCiclosCargaPC = 0;
        const datosCargaFPC = seriales.registroCargaPC ? await seriales.registroCargaPC.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : [];
        if (datosCargaFPC.length > 0) { //await decodificarTextoJSON(recibaSerial.registroInspeccionF) : []
          const datosCarga = await ObtenerDCargaPProduccion(datosCargaFPC);
          await Promise.all(datosCarga.map(async (carga) => {
            if (carga.fecha === pproduccion.fechaDePlaneacion && carga.hora <= ((hora ? hora : "") != "" ? hora : carga.hora)) {
              sumCargaPAPC += parseInt(carga.piezasenCarga ? carga.piezasenCarga : 0);
              empaquesCargaPC += parseInt(carga.materialEnCantidad ? carga.materialEnCantidad : 0);
              sumRacksCargaPC += parseFloat(carga.racks ? carga.racks : 0);
              sumCiclosCargaPC += parseInt(carga.ciclos ? carga.ciclos : 0);
            }
            return carga;
          }))
        }
        //Se obtienen los datos de pintado que corresponden al plan de producción indicado
        var sumPintadoPAPC = 0;
        const datosPintadoFPC = seriales.registroPintadoPC ? await seriales.registroPintadoPC.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : []
        if (datosPintadoFPC.length > 0) {
          const datosPintado = await ObtenerDPintadoPProduccion(datosPintadoFPC);
          await Promise.all(datosPintado.map(async (pintado) => {
            if (pintado.fecha === pproduccion.fechaDePlaneacion && pintado.hora <= ((hora ? hora : "") != "" ? hora : pintado.hora)) {
              sumPintadoPAPC = sumPintadoPAPC + pintado.piezasenPintado;
            }
            return pintado;
          }))
        }
        //Se obtienen los datos de inspección final que corresponden al plan de producción indicado
        var sumInspeccionFPAPC = 0;
        var sumInspeccionFPNAPC = 0;
        const datosInspeccionFPC = seriales.registroInspeccionFPC ? await seriales.registroInspeccionFPC.filter(datosPProduccion =>
          datosPProduccion.includes(pproduccion.id)) : [];
        if (datosInspeccionFPC.length > 0) {
          const datosInspeccion = await ObtenerDInspeccionFPProduccion(datosInspeccionFPC);
          await Promise.all(datosInspeccion.map(async (inspeccion) => {
            if (inspeccion.fecha === pproduccion.fechaDePlaneacion && inspeccion.hora <= ((hora ? hora : "") != "" ? hora : inspeccion.hora)) {
              sumInspeccionFPAPC = sumInspeccionFPAPC + parseInt(inspeccion.piezasAceptadas ? inspeccion.piezasAceptadas : 0);
              sumInspeccionFPNAPC = sumInspeccionFPNAPC + parseInt(inspeccion.piezasNoAceptadas ? inspeccion.piezasNoAceptadas : 0);
            }
            return inspeccion;
          }))
        }
        /*************************************************************************************************************/
        seriales.piezasAceptadasPG = sumInspeccionFPA;
        seriales.piezasNoAceptadasPG = sumInspeccionFPNA;
        totalInspeccionadoPG = totalInspeccionadoPG + (sumInspeccionFPA + sumInspeccionFPNA);
        seriales.piezasPintadoPG = sumPintadoPA;
        seriales.piezasCargaPG = sumCargaPA;
        seriales.numerosRacksCarga = RacksCarga;
        seriales.piezasAceptadasPGPC = sumInspeccionFPAPC;
        seriales.piezasNoAceptadasPGPC = sumInspeccionFPNAPC;
        totalInspeccionadoPGPC = totalInspeccionadoPGPC + (sumInspeccionFPAPC + sumInspeccionFPNAPC);
        seriales.piezasPintadoPGPC = sumPintadoPAPC;
        seriales.piezasCargaPGPC = sumCargaPAPC;

        seriales.racksPintadoPG = seriales.racks ? seriales.racks : sumRacksCarga ? sumRacksCarga : sumRacksCargaPC ? sumRacksCargaPC : 0;
        seriales.ciclosPintadoPG = seriales.ciclos ? seriales.ciclos : sumCiclosCarga ? sumCiclosCarga : sumCiclosCargaPC ? sumCiclosCargaPC : 0;
        seriales.empaquesCargaPG = empaquesCarga > 0 ? empaquesCarga : seriales.materialEnCantidad;
        pproduccionIDsg.push(seriales);
      } else {
        if (pPorSerial === false) {
          seriales.piezasAceptadasPG = seriales.piezasCalidad ? seriales.piezasCalidad : 0;
          seriales.piezasNoAceptadasPG = seriales.piezasNoAceptadas ? seriales.piezasNoAceptadas : 0;
          totalInspeccionadoPG = totalInspeccionadoPG + parseInt(seriales.piezasCalidad ? seriales.piezasCalidad : 0) +
            parseInt(seriales.piezasNoAceptadas ? seriales.piezasNoAceptadas : 0);
          seriales.piezasPintadoPG = seriales.piezasenPintado;
          seriales.piezasCargaPG = (seriales.piezasenPintado ? seriales.piezasenPintado : 0) + (seriales.piezasenCarga ? seriales.piezasenCarga : 0);
          seriales.racksPintadoPG = seriales.racks;
          seriales.ciclosPintadoPG = seriales.ciclos;
          seriales.empaquesCargaPG = seriales.materialEnCantidad;
          pproduccionIDsg.push(seriales);
        }
      }
    }
    return seriales;
  }))
  return { pproduccion: pproduccionIDsg, totalInspeccionado: totalInspeccionadoPG };
}
//Función que decodifica los seriales de un plan producción
export async function ObtenerInventario() {
  var totalInspeccionadoPG = 0;
  var totalPintadoPI = 0;
  const inventarioDatos = await GetRecibaSerialesMP({ and: [{ activo: { eq: true } }, { piezasEnPlanta: { eq: true } }] });
  //Se obtienen los clientes activos de la tabla cliente
  const clientes = await GetClientes({ activo: { eq: true } });
  var clientesInventario = clientes.map((item) => ({ cliente: item.cliente, clienteID: item.id, total: 0 }));
  var totalInventario = 0;
  await Promise.all(inventarioDatos.map(async (seriales) => {
    //Se obtiene el cliente del inventario
    const clienteID = seriales.clienteID;
    //Se verifica si el cliente ya existe en el arreglo
    const clienteExistente = clientesInventario.find(c => c.clienteID === clienteID);
    if (clienteExistente) {
      //Si el cliente ya existe, se suma la cantidad recibida por el precio unitario
      const total = (parseFloat(seriales.cantidadRecibida ? seriales.cantidadRecibida : 0) *
        parseFloat(seriales.precioUnitario ? seriales.precioUnitario : 0))
      clienteExistente.total += total;
      totalInventario += total;
    }
    //Facturado pendiente por embarcar
    if ((seriales.piezasCalidad) || (seriales.piezasNoAceptadas) || (seriales.PiezasEPintadas) || (seriales.PiezasENRecuperadas)) {

      //Se obtienen los datos de inspección final
      const totalPendiente = (parseInt(seriales.piezasCalidad ? seriales.piezasCalidad : 0) +
        parseInt(seriales.piezasNoAceptadas ? seriales.piezasNoAceptadas : 0)) -
        (parseInt(seriales.PiezasEPintadas ? seriales.PiezasEPintadas : 0) +
          parseInt(seriales.PiezasENRecuperadas ? seriales.PiezasENRecuperadas : 0));

      if (totalPendiente > 0 && seriales.precioUnitario) {

        totalInspeccionadoPG = totalInspeccionadoPG + (totalPendiente * seriales.precioUnitario);
        clientesInventario.push({})

      }
    }
    //Material pendiente por inspeccion
    if (seriales.piezasenPintado) {

      //Se obtienen los datos de inspección final
      const totalPendientePI = (parseInt(seriales.piezasenPintado ? seriales.piezasenPintado : 0)) -
        (parseInt(seriales.piezasCalidad ? seriales.piezasCalidad : 0) +
          parseInt(seriales.piezasNoAceptadas ? seriales.piezasNoAceptadas : 0));

      if (totalPendientePI > 0 && seriales.precioUnitario) {

        totalPintadoPI = totalPintadoPI + (totalPendientePI * seriales.precioUnitario);

      }
    }
    return seriales;
  }))
  clientesInventario = clientesInventario.filter(clienteE => clienteE.cliente).sort
    ((a, b) => (a.cliente > b.cliente ? 1 : a.cliente < b.cliente ? -1 : 0));;
  return {
    facturadoPE: totalInspeccionadoPG, totalPintadoPI: totalPintadoPI,
    inventarioClientes: clientesInventario, totalInventario: totalInventario
  };
}

export async function seguimientoProduccion(planeacionsf, hora) {
  //Ver seguimiento en plan de producción.
  var resultado = {
    costoTotalPVS: 0, costoTotalDVS: 0, costoTotalEVS: 0, sumPorcentajeT: 0, sumPorcentajeC: 0, planeacionsf: [],
    sumRacksSPB: 0, ciclosSPB: 0, sumPorcentajeTPC: 0, sumPorcentajeCPC: 0
  };
  var planeacionesANP = [];
  const planGenID = planeacionsf.filter(pgID => pgID.planeacionGeneralID);
  const planeacionGeneralID = planGenID.length > 0 ? planGenID[0].planeacionGeneralID : "";
  const PProduccionGeneral = await GetPProduccionGeneral({ and: [{ activo: { eq: true } }, { fechaDePlaneacion: { eq: planeacionsf[0].fechaDePlaneacion } }] });
  var PProduccion = [];
  if (PProduccionGeneral.length > 0) {
    const pprodreg = await ObtenerSerialesPProduccion(PProduccionGeneral[0], hora);
    PProduccion = pprodreg.pproduccion ? pprodreg.pproduccion : [];
  }
  //Se revisa si hay comentarios, si es así, se decodifican.
  const pbaseGeneral = planeacionGeneralID ? await GetPlaneacionBaseGeneralID(planeacionGeneralID) : {};
  const comentariosDeCod = pbaseGeneral.comentarios ? await decodificarComentariosPPB(pbaseGeneral.comentarios) : [];
  planeacionsf = planeacionsf.sort((a, b) =>
    a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);

  var sumCantidad = 0;
  var sumPiezaspintadas = 0;
  var sumPiezasCalidad = 0;
  var sumPiezaspintadasPC = 0;
  var sumPiezasCalidadPC = 0;
  //Se obtienen los productos para determinar los números de parte asociados
  const productos = await GetProductos({ activo: { eq: true } })
  //Se determina qué material está en la planeación base y cual material no.                
  var PProduccinSPB = []; //Registro que nó está en la planeación base.                
  await Promise.all(PProduccion.map(async (PProd) => {
    //Se determina el número de parte asociado
    //Suma de racks y ciclos 
    if (PProd.pintadoFechaHora) {
      if (PProd.pintadoFechaHora.includes(planeacionsf[0].fechaDePlaneacion)) {
        resultado.sumRacksSPB = resultado.sumRacksSPB + parseFloat(PProd.racks);
        resultado.ciclosSPB = resultado.ciclosSPB + parseFloat(PProd.ciclos);
        if (PProd.divisa === "Dólar")
          resultado.costoTotalDVS += parseFloat((PProd.precioUnitario ? PProd.precioUnitario : 0) * PProd.cantidadPiezas);
        if (PProd.divisa === "Euro")
          resultado.costoTotalEVS += parseFloat((PProd.precioUnitario ? PProd.precioUnitario : 0) * PProd.cantidadPiezas);
        if (PProd.divisa === "Peso mexicano")
          resultado.costoTotalPVS += parseFloat((PProd.precioUnitario ? PProd.precioUnitario : 0) * PProd.cantidadPiezas);
      }
    }

    const productoAsociado = productos.filter(producto => (producto.numerodeParte ? producto.numerodeParte.trim() : "") === PProd.numerodeParte.trim());
    const NPAsociado = productoAsociado[0] ? productoAsociado[0].numerodeParteAsociado : "";
    const pproduccionNP = planeacionsf.filter(PP => PP.numerodeParte.trim() === PProd.numerodeParte.trim());
    //Se determinan las piezas sin planificar pintadas
    //PProduccinSPB.push({ ...PProd, prioridadAtencion: "Sin planificar" });
    if ((PProd.numerodeParte.trim() != (NPAsociado ? NPAsociado.trim() : "") && pproduccionNP.length <= 0)) {
      if (PProd.pintadoFechaHora) {//Solo se toma en cuenta las piezas pintadas
        if ((PProd.pintadoFechaHora.includes(planeacionsf[0].fechaDePlaneacion))) {
          PProduccinSPB.push({ ...PProd, prioridadAtencion: "Sin planificar" });
        }
      }
      //Se toman en cuenta las piezas no planificadas de PowderCoat
      if (PProd.pintadoFechaHoraPC) {//Solo se toma en cuenta las piezas pintadas
        if ((PProd.pintadoFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion))) {
          PProduccinSPB.push({ ...PProd, prioridadAtencion: "Sin planificar" });
        }
      }
    }


  }));
  await Promise.all(planeacionsf.map(async (planeacion, j) => {
    var sumCarga = 0
    var sumPintado = 0;
    var sumInspeccion = 0;
    var sumCalidad = 0;
    var sumNoAceptados = 0;
    var sumCargaPC = 0
    var sumPintadoPC = 0;
    var sumCalidadPC = 0;
    var sumNoAceptadosPC = 0;
    //Se determina el número de parte asociado
    const productoAsociado = productos.filter(producto => (producto.numerodeParteAsociado ? producto.numerodeParteAsociado.trim() : "") === planeacion.numerodeParte.trim());
    const NPAsociado = productoAsociado[0] ? productoAsociado[0].numerodeParte : "";
    const pproduccionNP = PProduccion.filter(PP => PP.numerodeParte.trim() === planeacion.numerodeParte.trim() || PP.numerodeParte.trim() === (NPAsociado ? NPAsociado.trim() : ""));
    if (pproduccionNP.length) {
      await Promise.all(pproduccionNP.map(async (verPProduccion) => {
        //Datos Ecoat
        if (verPProduccion.cargaFechaHora) {
          sumCarga = sumCarga + (verPProduccion.cargaFechaHora.includes(planeacionsf[0].fechaDePlaneacion) ?
            verPProduccion.piezasenCarga : 0);
        }
        if (verPProduccion.inspeccionesFechaHora) {
          sumInspeccion = sumInspeccion + (verPProduccion.inspeccionesFechaHora.includes(planeacionsf[0].fechaDePlaneacion) ?
            verPProduccion.piezasInspeccion : 0);
        }
        if (verPProduccion.calidadFechaHora) {
          if ((verPProduccion.calidadFechaHora ? verPProduccion.calidadFechaHora.includes(planeacionsf[0].fechaDePlaneacion) : false)) {
            sumCalidad = sumCalidad + (verPProduccion.calidadFechaHora.includes(planeacionsf[0].fechaDePlaneacion) ?
              verPProduccion.piezasAceptadasPG : 0);
          }
        }
        if (verPProduccion.noAceptadasFechaHora) {
          if ((verPProduccion.noAceptadasFechaHora ? verPProduccion.noAceptadasFechaHora.includes(planeacionsf[0].fechaDePlaneacion) : false)) {
            sumNoAceptados = sumNoAceptados + (verPProduccion.noAceptadasFechaHora.includes(planeacionsf[0].fechaDePlaneacion) ?
              parseInt(verPProduccion.piezasNoAceptadasPG ? verPProduccion.piezasNoAceptadasPG : 0) : 0);
          }
        }
        if (verPProduccion.pintadoFechaHora) {
          sumPintado = sumPintado + (verPProduccion.pintadoFechaHora.includes(planeacionsf[0].fechaDePlaneacion) ?
            verPProduccion.piezasPintadoPG : 0);
        }
        //Datos Powder Coat
        if (verPProduccion.cargaFechaHoraPC) {
          sumCargaPC = sumCargaPC + (verPProduccion.cargaFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) ?
            verPProduccion.piezasenCargaPC : 0);
        }
        if (verPProduccion.calidadFechaHoraPC) {
          if ((verPProduccion.calidadFechaHoraPC ? verPProduccion.calidadFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) : false)) {
            sumCalidadPC = sumCalidadPC + (verPProduccion.calidadFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) ?
              verPProduccion.piezasAceptadasPGPC : 0);
          }
        }
        if (verPProduccion.noAceptadasFechaHoraPC) {
          if ((verPProduccion.noAceptadasFechaHoraPC ? verPProduccion.noAceptadasFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) : false)) {
            sumNoAceptadosPC = sumNoAceptadosPC + (verPProduccion.noAceptadasFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) ?
              parseInt(verPProduccion.piezasNoAceptadasPGPC ? verPProduccion.piezasNoAceptadasPGPC : 0) : 0);
          }
        }
        if (verPProduccion.pintadoFechaHoraPC) {
          sumPintadoPC = sumPintadoPC + (verPProduccion.pintadoFechaHoraPC.includes(planeacionsf[0].fechaDePlaneacion) ?
            verPProduccion.piezasPintadoPGPC : 0);
        }
      }));
    }
    /*planeacion.piezasenCarga = sumCarga;                    
    planeacion.piezasInspeccion = sumInspeccion;*/
    //Valores de Ecoat
    planeacion.piezasCalidad = sumCalidad;
    planeacion.piezasenPintado = sumPintado;
    planeacion.piezasNoAceptadas = sumNoAceptados;
    //Valores de Powder
    planeacion.piezasCalidadPC = sumCalidadPC;
    planeacion.piezasenPintadoPC = sumPintadoPC;
    planeacion.piezasNoAceptadasPC = sumNoAceptadosPC;

    //Suma de piezas Ecoat
    sumPiezaspintadas = sumPiezaspintadas + sumPintado;
    sumPiezasCalidad = sumPiezasCalidad + (sumCalidad + sumNoAceptados);
    sumCantidad = sumCantidad + planeacion.cantidadPiezas;

    //Suma de piezas Powder
    sumPiezaspintadasPC = sumPiezaspintadasPC + sumPintadoPC;
    sumPiezasCalidadPC = sumPiezasCalidadPC + (sumCalidadPC + sumNoAceptadosPC);
    return planeacion;
  }));
  //Porcentajes Ecoat
  resultado.sumPorcentajeT = ((sumPiezaspintadas * 100) / sumCantidad) % 1 == 0 ?
    ((sumPiezaspintadas * 100) / sumCantidad) :
    ((sumPiezaspintadas * 100) / sumCantidad).toFixed(2);
  resultado.sumPorcentajeC = ((sumPiezasCalidad * 100) / sumPiezaspintadas) % 1 == 0 ?
    ((sumPiezasCalidad * 100) / sumPiezaspintadas) :
    ((sumPiezasCalidad * 100) / sumPiezaspintadas).toFixed(2);
  //Porcentajes Powder
  resultado.sumPorcentajeTPC = ((sumPiezaspintadasPC * 100) / sumCantidad) % 1 == 0 ?
    ((sumPiezaspintadasPC * 100) / sumCantidad) :
    ((sumPiezaspintadasPC * 100) / sumCantidad).toFixed(2);
  resultado.sumPorcentajeCPC = ((sumPiezasCalidadPC * 100) / sumPiezaspintadasPC) % 1 == 0 ?
    ((sumPiezasCalidadPC * 100) / sumPiezaspintadasPC) :
    ((sumPiezasCalidadPC * 100) / sumPiezaspintadasPC).toFixed(2);


  //Se suman los registros sin planificar que se metieron al plan de producción.
  if (PProduccinSPB.length > 0) {
    var planeacionesSOANP = PProduccinSPB.sort((a, b) =>
      a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0);

    await Promise.all(planeacionesSOANP.map(async (planeacion, j) => {

      // Se obtienen  los datos de los comentarios en caso de existir
      const coment = comentariosDeCod.filter(np => np.cliente === planeacion.cliente && np.numerodeParte === planeacion.numerodeParte);

      const numerodeParte = planeacion.numerodeParte;
      const sumEmpaques = parseFloat(planeacion.empaquesCargaPG);
      const sumRacks = parseFloat(planeacion.racksPintadoPG);
      const sumCantidad = parseInt(planeacion.piezasPintadoPG ? planeacion.piezasPintadoPG : planeacion.piezasPintadoPGPC ? planeacion.piezasPintadoPGPC : 0);
      const sumCiclos = parseFloat(planeacion.ciclosPintadoPG);
      const sumPintado = parseInt(planeacion.piezasPintadoPG);
      const sumCalidad = parseInt(planeacion.piezasAceptadasPG);
      const sumNoAceptados = parseInt(planeacion.piezasNoAceptadasPG ? planeacion.piezasNoAceptadasPG : 0);
      const sumPintadoPC = parseInt(planeacion.piezasPintadoPGPC);
      const sumCalidadPC = parseInt(planeacion.piezasAceptadasPGPC);
      const sumNoAceptadosPC = parseInt(planeacion.piezasNoAceptadasPGPC ? planeacion.piezasNoAceptadasPGPC : 0);

      //Se verifica si el número de parte ya existe en el arreglo
      const numeroPExistente = planeacionesANP.find(c => c.numerodeParte === numerodeParte);
      if (numeroPExistente) {
        //Si el numerodeParte ya existe, se suman los datos 
        numeroPExistente.materialEnCantidad += sumEmpaques;
        numeroPExistente.piezasenPintado += sumPintado;
        numeroPExistente.racks += sumRacks;
        numeroPExistente.cantidadPiezas += sumCantidad;
        numeroPExistente.ciclos += sumCiclos;
        numeroPExistente.piezasCalidad += sumCalidad;
        numeroPExistente.piezasNoAceptadas += sumNoAceptados;
        numeroPExistente.piezasenPintadoPC += sumPintadoPC;
        numeroPExistente.piezasCalidadPC += sumCalidadPC;
        numeroPExistente.piezasNoAceptadasPC += sumNoAceptadosPC;
      } else {//Si el cliente no existe, se agrega a los arreglos correspondientes
        //clientescc.push(cliente); // Agrega el cliente al arreglo de clientes
        //cantidadPiezascc.push(cantidadPiezas); //Se agrega la cantidad de piezas al arreglo de cantidades
        planeacionesANP.push({
          ...planeacion, planeacionGeneralID: planeacionGeneralID, materialEnCantidad: sumEmpaques, prioridad: 0,
          racks: sumRacks, cantidadPiezas: sumCantidad, ciclos: sumCiclos, piezasCalidad: sumCalidad, piezasenPintado: sumPintado,
          piezasNoAceptadas: sumNoAceptados, comentariosProduccion: (coment[0] ? coment[0].comentarioPP : ""),
          comentarios: (coment[0] ? coment[0].comentarioPB : ""), piezasCalidadPC: sumCalidadPC, piezasenPintadoPC: sumPintadoPC,
          piezasNoAceptadasPC: sumNoAceptadosPC,
        });

      }
      return planeacion;
    }));
  }
  planeacionesANP = planeacionesANP.sort((a, b) =>
    a.cliente > b.cliente ? 1 : a.cliente < b.cliente ? -1 : 0);
  resultado.planeacionsf = [...planeacionsf, ...planeacionesANP];
  return resultado;
}

//Función que decodifica los seriales de un plan producción
export async function ObtenerSerialesPProduccionPS(pproduccion) {
  //Se obtienen los datos de los seriales pendientes en producción de la tabla temporal de recibaSeriales
  let filter = {
    and: [{
      activo: {
        eq: true
      }
    },
    {
      or: [{
        cantidadPlaneada: {
          gt: 0
        }
      },
      {
        cantidadPlaneadaPC: {
          gt: 0
        }
      }
      ]
    },
    ]
  }
  //Se obtienen los datos pendientes en producción de la tabla temporal de recibaSeriales
  var pendientes = await GetRecibaSerialesMP(filter);
  //Si hay datos del plan de produccion general
  if (pproduccion.id) {
    //Se revisa si los datos del plan de producción se guardaron por serial(no hay registro en la tabla de pproduccion, solo en las tablas de recibaSeriales).
    const pPorSerial = pproduccion.porSerial ? pproduccion.porSerial : false;
    const pproduccionIDs = pPorSerial === true ?
      (pproduccion.recibaSerialIDS ? pproduccion.recibaSerialIDS : []) :
      (pproduccion.PProduccionIDS ? pproduccion.PProduccionIDS : [])
    //const pproduccionIDs = (pproduccion.recibaSerialIDS ? pproduccion.recibaSerialIDS : []);
    await Promise.all(pproduccionIDs.map(async (x) => {
      const pproduccionID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
      if (pproduccionID) {
        const enPendientes = pendientes.filter(pendiente => pendiente.recibaSerialID === pproduccionID);
        if (enPendientes.length <= 0) {
          const seriales = pPorSerial === true ?
            await GetRecibaSerialesID(pproduccionID) : await GetPProduccionID(pproduccionID);
          if (seriales.activo === true) {
            pendientes.push(seriales)
          }
        }
      }
      return x;
    }))
  }
  return pendientes;
}
//Función que decodifica los seriales de un plan producción
export async function ObtenerSerialesPProduccionPC(pproduccion) {
  //Se obtienen los datos de los seriales pendientes en producción de la tabla temporal de recibaSeriales
  let filter = {
    and: [{
      activo: {
        eq: true
      }
    },
    {
      cantidadPlaneadaPC: {
        gt: 0
      }
    },
    ]
  }
  //Se obtienen los datos pendientes en producción de la tabla temporal de recibaSeriales
  var pendientes = await GetRecibaSerialesMP(filter);
  //Si hay datos del plan de produccion general
  if (pproduccion.id) {
    //Se revisa si los datos del plan de producción se guardaron por serial(no hay registro en la tabla de pproduccion, solo en las tablas de recibaSeriales).
    const pPorSerial = pproduccion.porSerial ? pproduccion.porSerial : false;
    const pproduccionIDs = pPorSerial === true ?
      (pproduccion.recibaSerialIDS ? pproduccion.recibaSerialIDS : []) :
      (pproduccion.PProduccionIDS ? pproduccion.PProduccionIDS : [])
    //const pproduccionIDs = (pproduccion.recibaSerialIDS ? pproduccion.recibaSerialIDS : []);
    await Promise.all(pproduccionIDs.map(async (x) => {
      const pproduccionID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
      if (pproduccionID) {
        const enPendientes = pendientes.filter(pendiente => pendiente.recibaSerialID === pproduccionID);
        if (enPendientes.length <= 0) {
          const seriales = pPorSerial === true ?
            await GetRecibaSerialesID(pproduccionID) : await GetPProduccionID(pproduccionID);
          if (seriales.activo === true) {
            pendientes.push(seriales)
          }
        }
      }
      return x;
    }))
  }
  return pendientes;
}

//Función que decodifica los datos de carga en producción
export async function ObtenerDCargaPProduccion(cargaDatos) {
  var pproduccionIDsg = [];
  //seriales.fechaDePlaneacion = pProduccionG.fechaDePlaneacion;
  /*produccionGID: pproduccionGID.id, fechaDePlaneacion: registroNuevoPP.fechaDePlaneacion,
              fecha: fechacarga, hora: horacarga, cantidadPiezas: registroNuevoPP.cantidadPiezas,
              materialEnCantidad: registroNuevoPP.materialEnCantidad, racks: registroNuevoPP.racks,
              piezasenCarga: registroNuevoPP.numeroRackCarga, ciclos: registroNuevoPP.ciclos,
              numeroRackCarga: registroNuevoPP.numeroRackCarga, Reg_Ins_Usuario: userName, 
               modulo: "Producción"
  */

  //Decodificación del historial de carga.
  //Decodificación del historial de producción.    

  await Promise.all(cargaDatos.map(async (x) => {
    const pproduccionGeneralID = x.substr(1, x.search(',') - 1).replace('produccionGID=', '');
    const fechaDePlaneacion = x.substr(x.search('fechaDePlaneacion=') + 17, x.length).substr(1, x.substr(x.search('fechaDePlaneacion=') + 17, x.length).search(',') - 1).replace('fechaDePlaneacion=', '');
    const fecha = x.search('fecha=') > 0 ? x.substr(x.search('fecha=') + 5, x.length).substr(1, x.substr(x.search('fecha=') + 5, x.length).search(',') - 1).replace('fecha=', '') : "";
    const hora = x.search('hora=') > 0 ? x.substr(x.search('hora=') + 4, x.length).substr(1, x.substr(x.search('hora=') + 4, x.length).search(',') - 1).replace('hora=', '') : "";
    const cantidadPiezas = x.substr(x.search('cantidadPiezas=') + 14, x.length).substr(1, x.substr(x.search('cantidadPiezas=') + 14, x.length).search(',') - 1).replace('cantidadPiezas=', '');
    const materialEnCantidad = x.search('materialEnCantidad=') > 0 ? x.substr(x.search('materialEnCantidad=') + 18, x.length).substr(1, x.substr(x.search('materialEnCantidad=') + 18, x.length).search(',') - 1).replace('materialEnCantidad=', '') : 0;
    const racks = x.search('racks=') > 0 ? x.substr(x.search('racks=') + 5, x.length).substr(1, x.substr(x.search('racks=') + 5, x.length).search(',') - 1).replace('racks=', '') : 0;
    const piezasenCarga = x.search('piezasenCarga=') > 0 ? x.substr(x.search('piezasenCarga=') + 13, x.length).substr(1, x.substr(x.search('piezasenCarga=') + 13, x.length).search(',') - 1).replace('piezasenCarga=', '') : 0;
    const ciclos = x.search('ciclos=') > 0 ? x.substr(x.search('ciclos=') + 6, x.length).substr(1, x.substr(x.search('ciclos=') + 6, x.length).search(',') - 1).replace('ciclos=', '') : 0;
    const numeroRackCarga = x.search('numeroRackCarga=') > 0 ? x.substr(x.search('numeroRackCarga=') + 15, x.length).substr(1, x.substr(x.search('numeroRackCarga=') + 15, x.length).search(',') - 1).replace('numeroRackCarga=', '') : "";
    const Reg_Ins_FH = x.search('Reg_Ins_FH=') > 0 ? x.substr(x.search('Reg_Ins_FH=') + 10, x.length).substr(1, x.substr(x.search('Reg_Ins_FH=') + 10, x.length).search(',') - 1).replace('Reg_Ins_FH=', '') : "";
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1,
      (x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') ? x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') :
        x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search('}')) - 1).replace('Reg_Ins_Usuario=', '');
    const modulo = x.search('modulo=') > 0 ? x.substr(x.search('modulo=') + 6, x.length).substr(1, x.substr(x.search('modulo=') + 6, x.length).search('}') - 1).replace('modulo=', '') : "";
    pproduccionIDsg.push({
      pproduccionGeneralID: pproduccionGeneralID,
      fechaDePlaneacion: fechaDePlaneacion,
      fecha: fecha,
      hora: hora,
      cantidadPiezas: parseInt(cantidadPiezas),
      materialEnCantidad: parseInt(materialEnCantidad),
      racks: parseFloat(racks),
      piezasenCarga: parseInt(piezasenCarga),
      ciclos: parseFloat(ciclos),
      numeroRackCarga: numeroRackCarga,
      Reg_Ins_FH: Reg_Ins_FH,
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      modulo: modulo
    })
  }));

  return pproduccionIDsg;
}
//Función que decodifica los datos de pintado en producción
export async function ObtenerDPintadoPProduccion(pintadoDatos) {
  var pproduccionIDsg = [];
  /*const datosPintado = {
    produccionGID: pproduccionGID, fechaDePlaneacion: pproduccion.fechaDePlaneacion,
    fecha: fecha, hora: hora, cantidadPiezas: pproduccion.cantidadPiezas,
    piezasenPintado: pproduccion.piezasenCarga, racks: pproduccion.racks,
    ciclos: pproduccion.ciclos, Reg_Ins_Usuario: userName, modulo: "Producción"
  */

  //Decodificación del historial de pintado.
  await Promise.all(pintadoDatos.map(async (x) => {
    const pproduccionGeneralID = x.substr(1, x.search(',') - 1).replace('produccionGID=', '');
    const fechaDePlaneacion = x.substr(x.search('fechaDePlaneacion=') + 17, x.length).substr(1, x.substr(x.search('fechaDePlaneacion=') + 17, x.length).search(',') - 1).replace('fechaDePlaneacion=', '');
    const fecha = x.search('fecha=') > 0 ? x.substr(x.search('fecha=') + 5, x.length).substr(1, x.substr(x.search('fecha=') + 5, x.length).search(',') - 1).replace('fecha=', '') : "";
    const hora = x.search('hora=') > 0 ? x.substr(x.search('hora=') + 4, x.length).substr(1, x.substr(x.search('hora=') + 4, x.length).search(',') - 1).replace('hora=', '') : "";
    const cantidadPiezas = x.substr(x.search('cantidadPiezas=') + 14, x.length).substr(1, x.substr(x.search('cantidadPiezas=') + 14, x.length).search(',') - 1).replace('cantidadPiezas=', '');
    const piezasenPintado = x.search('piezasenPintado=') > 0 ? x.substr(x.search('piezasenPintado=') + 15, x.length).substr(1, x.substr(x.search('piezasenPintado=') + 15, x.length).search(',') - 1).replace('piezasenPintado=', '') : 0;
    const racks = x.search('racks=') > 0 ? x.substr(x.search('racks=') + 5, x.length).substr(1, x.substr(x.search('racks=') + 5, x.length).search(',') - 1).replace('racks=', '') : 0;
    const ciclos = x.search('ciclos=') > 0 ? x.substr(x.search('ciclos=') + 6, x.length).substr(1, x.substr(x.search('ciclos=') + 6, x.length).search(',') - 1).replace('ciclos=', '') : 0;
    const Reg_Ins_FH = x.search('Reg_Ins_FH=') > 0 ? x.substr(x.search('Reg_Ins_FH=') + 10, x.length).substr(1, x.substr(x.search('Reg_Ins_FH=') + 10, x.length).search(',') - 1).replace('Reg_Ins_FH=', '') : "";
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1,
      (x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') ? x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') :
        x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search('}')) - 1).replace('Reg_Ins_Usuario=', '');
    const modulo = x.search('modulo=') > 0 ? x.substr(x.search('modulo=') + 6, x.length).substr(1, x.substr(x.search('modulo=') + 6, x.length).search('}') - 1).replace('modulo=', '') : "";
    pproduccionIDsg.push({
      pproduccionGeneralID: pproduccionGeneralID,
      fechaDePlaneacion: fechaDePlaneacion,
      fecha: fecha,
      hora: hora,
      cantidadPiezas: parseInt(cantidadPiezas),
      piezasenPintado: parseInt(piezasenPintado),
      racks: parseFloat(racks),
      ciclos: parseFloat(ciclos),
      Reg_Ins_FH: Reg_Ins_FH,
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      modulo: modulo
    })
  }));

  return pproduccionIDsg;
}
//Función que decodifica los datos de pintado en producción
export async function ObtenerDInspeccionFPProduccion(inspeccionFDatos) {
  var pproduccionIDsg = [];
  /*const datosInspeccionF = {
    produccionGID: pproduccionGID, fechaDePlaneacion: pInspeccion.fechaDePlaneacion, fecha: fecha,
    hora: hora, cantidadPiezas: pInspeccion.cantidadPiezas, piezasAceptadas: pInspeccion.piezasEnInspeccionando,
    piezasNoAceptadas: pInspeccion.piezasNoAceptadas, defecto: pInspeccion.pnadefecto,
    pnaotroDefecto: pInspeccion.pnaotroDefecto, comentariosInspeccion: pInspeccion.comentariosInspeccion,
    racks: pInspeccion.racks, ciclos: pInspeccion.ciclos, Reg_Ins_Usuario: userName, modulo: "Calidad"
    }
  */

  //Decodificación del historial de pintado.
  await Promise.all(inspeccionFDatos.map(async (x) => {
    const pproduccionGeneralID = x.substr(1, x.search(',') - 1).replace('produccionGID=', '');
    const fechaDePlaneacion = x.substr(x.search('fechaDePlaneacion=') + 17, x.length).substr(1, x.substr(x.search('fechaDePlaneacion=') + 17, x.length).search(',') - 1).replace('fechaDePlaneacion=', '');
    const fecha = x.search('fecha=') > 0 ? x.substr(x.search('fecha=') + 5, x.length).substr(1, x.substr(x.search('fecha=') + 5, x.length).search(',') - 1).replace('fecha=', '') : "";
    const hora = x.search('hora=') > 0 ? x.substr(x.search('hora=') + 4, x.length).substr(1, x.substr(x.search('hora=') + 4, x.length).search(',') - 1).replace('hora=', '') : "";
    const cantidadPiezas = x.substr(x.search('cantidadPiezas=') + 14, x.length).substr(1, x.substr(x.search('cantidadPiezas=') + 14, x.length).search(',') - 1).replace('cantidadPiezas=', '');
    const piezasAceptadas = x.search('piezasAceptadas=') > 0 ? x.substr(x.search('piezasAceptadas=') + 15, x.length).substr(1, x.substr(x.search('piezasAceptadas=') + 15, x.length).search(',') - 1).replace('piezasAceptadas=', '') : 0;
    const piezasNoAceptadas = x.search('piezasNoAceptadas=') > 0 ? x.substr(x.search('piezasNoAceptadas=') + 17, x.length).substr(1, x.substr(x.search('piezasNoAceptadas=') + 17, x.length).search(',') - 1).replace('piezasNoAceptadas=', '') : 0;
    const defecto = x.search('defecto=') > 0 ? x.substr(x.search('defecto=') + 7, x.length).substr(1, x.substr(x.search('defecto=') + 7, x.length).search(',') - 1).replace('defecto=', '') : "";
    const pnaotroDefecto = x.search('pnaotroDefecto=') > 0 ? x.substr(x.search('pnaotroDefecto=') + 14, x.length).substr(1, x.substr(x.search('pnaotroDefecto=') + 14, x.length).search(',') - 1).replace('pnaotroDefecto=', '') : "";
    const comentariosInspeccion = x.search('comentariosInspeccion=') > 0 ? x.substr(x.search('comentariosInspeccion=') + 21, x.length).substr(1, x.substr(x.search('comentariosInspeccion=') + 21, x.length).search(',') - 1).replace('comentariosInspeccion=', '') : "";
    const racks = x.search('racks=') > 0 ? x.substr(x.search('racks=') + 5, x.length).substr(1, x.substr(x.search('racks=') + 5, x.length).search(',') - 1).replace('racks=', '') : 0;
    const ciclos = x.search('ciclos=') > 0 ? x.substr(x.search('ciclos=') + 6, x.length).substr(1, x.substr(x.search('ciclos=') + 6, x.length).search(',') - 1).replace('ciclos=', '') : 0;
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1,
      (x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') ? x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') :
        x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search('}')) - 1).replace('Reg_Ins_Usuario=', '');
    const numeroRackCarga = x.substr(x.search('numeroRackCarga=') + 15, x.length).substr(1,
      (x.substr(x.search('numeroRackCarga=') + 15, x.length).search(',') ? x.substr(x.search('numeroRackCarga=') + 15, x.length).search(',') :
        x.substr(x.search('numeroRackCarga=') + 15, x.length).search('}')) - 1).replace('numeroRackCarga=', '');
    const modulo = x.search('modulo=') > 0 ? x.substr(x.search('modulo=') + 6, x.length).substr(1, x.substr(x.search('modulo=') + 6, x.length).search('}') - 1).replace('modulo=', '') : "";
    pproduccionIDsg.push({
      pproduccionGeneralID: pproduccionGeneralID,
      fechaDePlaneacion: fechaDePlaneacion,
      fecha: fecha,
      hora: hora,
      cantidadPiezas: parseInt(cantidadPiezas),
      piezasAceptadas: parseInt(piezasAceptadas),
      piezasNoAceptadas: parseInt(piezasNoAceptadas ? piezasNoAceptadas : 0),
      defecto: defecto,
      pnaotroDefecto: pnaotroDefecto,
      comentariosInspeccion: comentariosInspeccion,
      racks: parseFloat(racks),
      ciclos: parseFloat(ciclos),
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      numeroRackCarga: numeroRackCarga,
      modulo: modulo
    })
  }));

  return pproduccionIDsg;
}
//Función que decodifica los seriales de un plan producción
export async function ObtenerSerialesEmbarques(embarqueIDs) {
  var embarqueIDsg = [];
  await Promise.all(await embarqueIDs.map(async (x) => {
    const embarqueSerialID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const serialesE = await GetEmbarquesSerialesID(embarqueSerialID);
    if (serialesE.activo == true) {
      embarqueIDsg.push(serialesE)
    }
    return x;
  }))
  return embarqueIDsg;
}
//Función que decodifica los id de seriales proporcionados
export async function combinarIDS(IDSA, IDSN) {
  var salidaIDS = [];
  await Promise.all(IDSN.map(async (x) => {
    if (x.nuevo === true) {
      salidaIDS.push({
        id: x.id,
      })
    }
    return x;
  }))
  await Promise.all(IDSA.map(async (x) => {
    const SID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    const salidaIDNuevo = IDSN.filter(pp => pp.id === SID && pp.activo === false);
    if (salidaIDNuevo.length <= 0) {
      salidaIDS.push({
        id: SID,
      })
    }
    return x;
  }))
  return salidaIDS;
}
//Función que decodifica los datos de servicios extra de la facturación
export async function ObtenerServiciosFacturacion(servicios) {
  //{quantity=1, description=10 HOURS SUPPLY URGENT PARTS ZINC PLATING, uprice=2200, total=2200.00, createdAt=2024-07-09T18:00:15.721Z,
  //  updatedAt=, Reg_Ins_Usuario=GELACIA.PALACIOS, Reg_Mod_Usuario=
  var aServicios = [];
  var sumTotal = 0;
  var sumSubTotal = 0;
  var sumTotalDes = 0;
  servicios.map((x) => {
    const quantity = x.substr(1, x.search(',') - 1).replace('quantity=', '');
    const description = x.substr(x.search('description=') + 11, x.length).substr(1, x.substr(x.search('description=') + 11, x.length).search(',') - 1).replace('description=', '');
    const uprice = x.substr(x.search('uprice=') + 6, x.length).substr(1, x.substr(x.search('uprice=') + 6, x.length).search(',') - 1).replace('uprice=', '');
    const subTotal = x.substr(x.search('subTotal=') + 8, x.length).substr(1, x.substr(x.search('subTotal=') + 8, x.length).search(',') - 1).replace('subTotal=', '');
    const discount = x.substr(x.search('discount=') + 8, x.length).substr(1, x.substr(x.search('discount=') + 8, x.length).search(',') - 1).replace('discount=', '');
    const total = x.substr(x.search('total=') + 5, x.length).substr(1, x.substr(x.search('total=') + 5, x.length).search(',') - 1).replace('total=', '');
    const createdAt = x.substr(x.search('createdAt=') + 9, x.length).substr(1, x.substr(x.search('createdAt=') + 9, x.length).search(',') - 1).replace('createdAt=', '');
    const updatedAt = x.substr(x.search('updatedAt=') + 9, x.length).substr(1, x.substr(x.search('updatedAt=') + 9, x.length).search(',') - 1).replace('updatedAt=', '');
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') - 1).replace('Reg_Ins_Usuario=', '');
    const Reg_Mod_Usuario = x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).search('}') - 1).replace('Reg_Mod_Usuario=', '');
    sumTotal = sumTotal + parseFloat(total);
    sumSubTotal = sumSubTotal + parseFloat(subTotal);
    sumTotalDes = sumTotalDes + parseFloat(discount);
    aServicios.push({
      quantity: quantity,
      description: description,
      uprice: parseFloat(uprice),
      subTotal: parseFloat(subTotal),
      discount: parseFloat(discount),
      total: parseFloat(total),
      createdAt: createdAt,
      updatedAt: updatedAt,
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      Reg_Mod_Usuario: Reg_Mod_Usuario
    })

  })
  return { servicios: aServicios, total: sumTotal, subTotal: sumSubTotal, discounTotal: sumTotalDes };
}
//Función que decodifica los datos de servicios extra del embarque
export async function ObtenerServiciosEmbarques(servicios) {
  /*
  orden: 0, materialEnCantidad: 0, numerodeParte: "", serial: "",
     descripcion: "", shipper: "", materialEn: "Contenedor", piezas: 0, totalPiezas: 0,
     totalCantidad: 0, precioUnitario: 0.0, divisa: "Dólar", createdAt: "",
     updatedAt: "", Reg_Ins_Usuario: userName, Reg_Mod_Usuario: ""
   */
  var aServicios = [];
  var totalContenedores = 0;
  var totalCaja = 0;
  var totalTarima = 0;
  var totalD = 0;
  var subTotalD = 0;
  var desTotalD = 0;
  var totalEmbarcadas = 0;
  servicios.map((x) => {
    const orden = x.substr(1, x.search(',') - 1).replace('orden=', '');
    const materialEnCantidad = x.substr(x.search('materialEnCantidad=') + 18, x.length).substr(1, x.substr(x.search('materialEnCantidad=') + 18, x.length).search(',') - 1).replace('materialEnCantidad=', '');
    const numerodeParte = x.substr(x.search('numerodeParte=') + 13, x.length).substr(1, x.substr(x.search('numerodeParte=') + 13, x.length).search(',') - 1).replace('numerodeParte=', '');
    const serial = x.substr(x.search('serial=') + 6, x.length).substr(1, x.substr(x.search('serial=') + 6, x.length).search(',') - 1).replace('serial=', '');
    const descripcion = x.substr(x.search('descripcion=') + 11, x.length).substr(1, x.substr(x.search('descripcion=') + 11, x.length).search(',') - 1).replace('descripcion=', '');
    const shipper = x.substr(x.search('shipper=') + 7, x.length).substr(1, x.substr(x.search('shipper=') + 7, x.length).search(',') - 1).replace('shipper=', '');
    const materialEn = x.substr(x.search('materialEn=') + 10, x.length).substr(1, x.substr(x.search('materialEn=') + 10, x.length).search(',') - 1).replace('materialEn=', '');
    const Contenedor = x.substr(x.search('Contenedor=') + 10, x.length).substr(1, x.substr(x.search('Contenedor=') + 10, x.length).search(',') - 1).replace('Contenedor=', '');
    const piezasPintadas = x.substr(x.search('piezasPintadas=') + 14, x.length).substr(1, x.substr(x.search('piezasPintadas=') + 14, x.length).search(',') - 1).replace('piezasPintadas=', '');
    const totalPiezas = x.substr(x.search('totalPiezas=') + 11, x.length).substr(1, x.substr(x.search('totalPiezas=') + 11, x.length).search(',') - 1).replace('totalPiezas=', '');
    const totalCantidad = x.substr(x.search('totalCantidad=') + 13, x.length).substr(1, x.substr(x.search('totalCantidad=') + 13, x.length).search(',') - 1).replace('totalCantidad=', '');
    const precioUnitario = x.substr(x.search('precioUnitario=') + 14, x.length).substr(1, x.substr(x.search('precioUnitario=') + 14, x.length).search(',') - 1).replace('precioUnitario=', '');
    const precioUnitarioTot = x.search('precioUnitarioTot=') > 0 ? x.substr(x.search('precioUnitarioTot=') + 17, x.length).substr(1, x.substr(x.search('precioUnitarioTot=') + 17, x.length).search(',') - 1).replace('precioUnitarioTot=', '') : "0";
    const divisa = x.substr(x.search('divisa=') + 6, x.length).substr(1, x.substr(x.search('divisa=') + 6, x.length).search(',') - 1).replace('divisa=', '');
    const precioTotal = x.substr(x.search('precioTotal=') + 11, x.length).substr(1, x.substr(x.search('precioTotal=') + 11, x.length).search(',') - 1).replace('precioTotal=', '');
    const createdAt = x.substr(x.search('createdAt=') + 9, x.length).substr(1, x.substr(x.search('createdAt=') + 9, x.length).search(',') - 1).replace('createdAt=', '');
    const updatedAt = x.substr(x.search('updatedAt=') + 9, x.length).substr(1, x.substr(x.search('updatedAt=') + 9, x.length).search(',') - 1).replace('updatedAt=', '');
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') - 1).replace('Reg_Ins_Usuario=', '');
    const Reg_Mod_Usuario = x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).search(',') - 1).replace('Reg_Mod_Usuario=', '');
    const descuento = x.substr(x.search('descuento=') + 9, x.length).substr(1, x.substr(x.search('descuento=') + 9, x.length).search(',') - 1).replace('descuento=', '');
    const precioSubTotalSDV = x.search('precioUnitarioTot=') > 0 ? x.substr(x.search('precioSubTotalSDV=') + 17, x.length).substr(1, x.substr(x.search('precioSubTotalSDV=') + 17, x.length).search(',') - 1).replace('precioSubTotalSDV=', '') : 0;
    const divisaPS = x.substr(x.search('divisaPS=') + 8, x.length).substr(1, x.substr(x.search('divisaPS=') + 8, x.length).search('}') - 1).replace('divisaPS=', '');
    //sumTotal = sumTotal + parseFloat(total);
    aServicios.push({
      orden: parseInt(orden),
      materialEnCantidad: materialEnCantidad,
      numerodeParte: numerodeParte,
      serial: serial,
      descripcion: descripcion,
      shipper: shipper,
      materialEn: materialEn,
      Contenedor: Contenedor,
      piezasPintadas: piezasPintadas ? parseInt(piezasPintadas) : 0,
      totalPiezas: totalPiezas,
      totalCantidad: totalCantidad,
      precioUnitario: precioUnitario ? parseFloat(precioUnitario) : 0,
      precioUnitarioTot: precioUnitarioTot !== "0" ? parseFloat(precioUnitarioTot) : precioUnitarioTot ? parseFloat(precioUnitario) : 0,
      divisa: divisa,
      precioTotal: precioTotal,
      createdAt: createdAt,
      updatedAt: updatedAt,
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      Reg_Mod_Usuario: Reg_Mod_Usuario,
      descuento: descuento,
      precioSubTotalSDV: precioSubTotalSDV,
      divisaPS: divisaPS
    })

    totalD = parseFloat(totalD) + (parseFloat(precioUnitarioTot) * parseFloat(piezasPintadas));
    desTotalD = parseFloat(desTotalD) + (parseFloat(descuento));
    subTotalD = parseFloat(subTotalD) + (parseFloat(precioSubTotalSDV));
    totalEmbarcadas = parseInt(totalEmbarcadas) + parseInt(piezasPintadas);
    //Se o5btiene el total de cajas, contenedores y tarimas.
    if (materialEn === "Caja") {
      totalCaja = parseFloat(totalCaja) + parseFloat(materialEnCantidad);
    }
    if (materialEn === "Contenedor") {
      totalContenedores = parseFloat(totalContenedores) + parseFloat(materialEnCantidad);
    }
    if (materialEn === "Tarima") {
      totalTarima = parseFloat(totalTarima) + parseFloat(materialEnCantidad);
    }

    return x;
  })
  return {
    servicios: aServicios.sort((a, b) => (a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0)),
    totalCaja: totalCaja, totalContenedores: totalContenedores, totalTarima: totalTarima,
    totalD: totalD, totalEmbarcadas: totalEmbarcadas, desTotalD: desTotalD, subTotalD: subTotalD
  };//{ servicios: aServicios, total: sumTotal };
}
//Función que decodifica los serialesID
export async function decodificarIDS(IDs) {
  var serialesID = [];
  await Promise.all(IDs.map(async (x) => {
    const serialID = x.substr(x.search('id=') + 2, x.length).substr(1, x.substr(x.search('id=') + 2, x.length).search('}') - 1).replace('id=', '');
    serialesID.push({
      id: serialID,
    })
    return x;
  }))
  return serialesID;
}
//Función que decodifica los comentarios de los números de parte sin planificar en una planeación base
export async function decodificarComentariosPPB(comentarios) {
  /*
  const datosComentarios = [{
          cliente: planeacion.cliente, numerodeParte: planeacion.numerodeParte,
          comentarioPB: comentarioPB, comentarioPP: comentarioPP, Reg_Ins_Usuario: userName,
          Reg_Ins_Fecha: fechaOpreacion, Reg_Mod_Usuario: userName, Reg_Mod_Fecha: fechaOpreacion
        }]
  */
  var comentariosDeCod = [];
  comentarios.map((x) => {
    const cliente = x.substr(1, x.search(',') - 1).replace('cliente=', '');
    const numerodeParte = x.substr(x.search('numerodeParte=') + 13, x.length).substr(1, x.substr(x.search('numerodeParte=') + 13, x.length).search(',') - 1).replace('numerodeParte=', '');
    const comentarioPB = x.substr(x.search('comentarioPB=') + 12, x.length).substr(1, x.substr(x.search('comentarioPB=') + 12, x.length).search('comentarioPP=') - 3).replace('comentarioPB=', '');
    const comentarioPP = x.substr(x.search('comentarioPP=') + 12, x.length).substr(1, x.substr(x.search('comentarioPP=') + 12, x.length).search('Reg_Ins_Usuario=') - 3).replace('comentarioPP=', '');
    const Reg_Ins_Usuario = x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Ins_Usuario=') + 15, x.length).search(',') - 1).replace('Reg_Ins_Usuario=', '');
    const Reg_Ins_Fecha = x.substr(x.search('Reg_Ins_Fecha=') + 13, x.length).substr(1, x.substr(x.search('Reg_Ins_Fecha=') + 13, x.length).search(',') - 1).replace('Reg_Ins_Fecha=', '');
    const Reg_Mod_Usuario = x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).substr(1, x.substr(x.search('Reg_Mod_Usuario=') + 15, x.length).search(',') - 1).replace('Reg_Mod_Usuario=', '');
    const Reg_Mod_Fecha = x.substr(x.search('Reg_Mod_Fecha=') + 13, x.length).substr(1, x.substr(x.search('Reg_Mod_Fecha=') + 13, x.length).search('}') - 1).replace('Reg_Mod_Fecha=', '');

    comentariosDeCod.push({
      cliente: cliente,
      numerodeParte: numerodeParte,
      comentarioPB: comentarioPB,
      comentarioPP: comentarioPP,
      Reg_Ins_Usuario: Reg_Ins_Usuario,
      Reg_Ins_Fecha: Reg_Ins_Fecha,
      Reg_Mod_Usuario: Reg_Mod_Usuario,
      Reg_Mod_Fecha: Reg_Mod_Fecha,
    })

  })
  return comentariosDeCod;
}

//Función que decodifica los datos del inventario de los clientes del resumen de operaciones
export async function decodificarInventarioCliente(inventarioCliente, fecha) {
  //{quantity=1, description=10 HOURS SUPPLY URGENT PARTS ZINC PLATING, uprice=2200, total=2200.00, createdAt=2024-07-09T18:00:15.721Z,
  //  updatedAt=, Reg_Ins_Usuario=GELACIA.PALACIOS, Reg_Mod_Usuario=
  var dinventarioC = [];
  var sumTotal = 0;
  inventarioCliente.map((x) => {
    const cliente = x.substr(1, x.search(',') - 1).replace('cliente=', '');
    const total = x.substr(x.search('total=') + 5, x.length).substr(1, x.substr(x.search('total=') + 5, x.length).search('}') - 1).replace('total=', '');
    sumTotal = sumTotal + parseFloat(total);
    dinventarioC.push({
      cliente: cliente,
      total: parseFloat(total),
      fecha: fecha
    })

  })
  return { inventarioClientes: dinventarioC, total: sumTotal };
}

//Función que obtiene los seriales en planta.
export async function ObtenerRecibaSeriales(dato) {
  var seriales = [];
  const serialesMP = await GetRecibaSerialesMP();
  await Promise.all(serialesMP.map(async (serialesID) => {
    const rseriales = await GetRecibaSerialesID(serialesID.id);
    if (rseriales.activo === true && rseriales.piezasEnPlanta === true) {
      seriales.push(rseriales)
    }
    return serialesID;
  }))
  return seriales;
}


export async function datosRSerial(dato) {
  const datoE = dato.substr(0, 2).toLowerCase() === "3s" ? dato.substr(2, dato.length) : dato;
  let filter = {
    and: [
      {
        or: [{
          serialRecibaBTI: {
            eq: dato.toUpperCase(),
          }
        },
        {
          serial: {
            eq: datoE,
          },
        }, {
          serial: {
            eq: dato,
          },
        }, {
          recibaSerialID: {
            eq: dato,
          }
        },
        ]
      },
      {
        activo: {
          eq: true,
        },
      },
      {
        piezasEnPlanta: {
          eq: true,
        },
      },
    ],
  }

  //Se obtienen los datos de los seriales.
  var apiData = await GetRecibaSerialesMP(filter);
  const recibaFromAPI = apiData.sort((a, b) =>
    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0
  );

  await Promise.all(
    recibaFromAPI.map(async (reciba) => {
      reciba.piezasPintadas = reciba.piezasPintadas ? reciba.piezasPintadas -
        ((reciba.PiezasEPintadas ? reciba.PiezasEPintadas : 0) +
          ((reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0) === 0 ?
            (reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) :
            (reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0) >=
              (reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) ? 0 :
              ((reciba.PiezasENRecuperadas ? reciba.PiezasENRecuperadas : 0) -
                (reciba.piezasNRecuperadas ? reciba.piezasNRecuperadas : 0))))
        : 0;
      reciba.piezasPintadasDisponibles = reciba.piezasPintadas;
      reciba.PiezasNRecuperadasDisponibles = reciba.piezasCtnaPintadas;

      const piezasTotales = (parseInt(reciba.piezasCalidad ? reciba.piezasCalidad : 0) +
        (parseInt(reciba.piezasNoAceptadas ? reciba.piezasNoAceptadas : 0)));

      reciba.piezasEnInspeccionando = (parseInt(reciba.piezasenPintado) - piezasTotales) < 0 ? 0 :
        (parseInt(reciba.piezasenPintado) - piezasTotales);
      reciba.piezasDisponibles = reciba.piezasEnInspeccionando;


      return reciba;
    })
  );
  return recibaFromAPI;
}
//Obtiene los datos guardados de las planeaciones bases activas por fecha 
export async function obtenerPlaneacionBF(fecha) {
  //Filtro por planeación activa y fecha de planeación
  let filter = {
    and: [{
      activo: {
        eq: true
      }
    },
    {
      fechaDePlaneacion: {
        eq: fecha
      }
    }]
  }

  //Se obtienen los registros generales de la planeación base de la fecha especificada
  const apiData = await GetPlaneacionBaseGeneral(filter);

  //Se obtienen los datos de la planeación base
  const pb = apiData[0] ? await ObtenerSerialesPlaneacionBase(apiData[0].PlaneacionBIDS) : [];
  var planeacionsf = pb.planeacionBase ? pb.planeacionBase : [];
  // var planeacionsf = apiData[0] ? await ObtenerSerialesPlaneacionBase(apiData[0].PlaneacionBIDS) : [];
  return planeacionsf;
}

//Función que obtiene los datos agrupados de la planeación base por fecha
//para las métricas.
export async function obtenerDatosPBF(fecha) {
  //Se obtienen los datos de la planeación base por fecha
  const datosPBF = await obtenerPlaneacionBF(fecha);
  var datoscc = [];
  var racks = 0;
  var ciclos = 0;
  var cantidadTotalPiezas = 0;
  const datosPBOrdenada = datosPBF.sort((a, b) => a.cliente.localeCompare(b.cliente));
  //Se recorren los datos de la planeación base
  await Promise.all(datosPBOrdenada.map(async (planeacion) => {
    //Se obtiene el cliente de la planeación
    const cliente = planeacion.cliente;
    //Se obtiene el número de parte de la planeación
    const numeroParte = planeacion.numerodeParte;
    //Se obtiene la cantidad de piezas de la planeación
    const cantidadPiezas = planeacion.cantidadPiezas;
    cantidadTotalPiezas += planeacion.cantidadPiezas;
    //Se obtienen los racks de la planeación
    const rackscc = parseFloat(planeacion.racks ? planeacion.racks : 0);
    //Se suman los racks de la planeación
    racks += parseFloat(planeacion.racks ? planeacion.racks : 0);
    //se obtiene los ciclos de la planeación
    const cicloscc = parseInt(planeacion.ciclos ? planeacion.ciclos : 0);
    //Se suman los ciclos de la planeación
    ciclos += parseInt(planeacion.ciclos ? planeacion.ciclos : 0);

    //Se verifica si el cliente ya existe en el arreglo
    const clienteExistente = datoscc.find(c => c.cliente === cliente);
    if (clienteExistente) {
      //Si el cliente ya existe, se suma la cantidad de piezas
      clienteExistente.cantidadPiezas += cantidadPiezas;
      clienteExistente.racks += rackscc;
      clienteExistente.ciclos += cicloscc;
    } else {//Si el cliente no existe, se agrega a los arreglos correspondientes
      //clientescc.push(cliente); // Agrega el cliente al arreglo de clientes
      //cantidadPiezascc.push(cantidadPiezas); //Se agrega la cantidad de piezas al arreglo de cantidades
      datoscc.push({ //Se agregan todos los datos al arreglo de datos
        cliente: cliente,
        numeroParte: numeroParte,
        cantidadPiezas: cantidadPiezas,
        racks: rackscc,
        ciclos: cicloscc
      });
    }
  }));

  //Se obtienen los datos de la columna cliente
  const clientescc = datoscc.map(clientes => clientes.cliente);
  //Se obtienen los datos de la columna rcantidadPiezas
  const cantidadPiezascc = datoscc.map(cantidad => cantidad.cantidadPiezas);
  //Se calcula el porcentaje de piezas por cliente
  const porcentajePiezasPorCliente = cantidadPiezascc.map(cantidad => (cantidad / cantidadTotalPiezas) * 100);
  return {
    clientes: clientescc, cantidadPiezas: cantidadPiezascc, datos: datoscc,
    porcentajes: porcentajePiezasPorCliente, totalPiezas: cantidadTotalPiezas,
    totalRacks: racks, totalCiclos: ciclos
  };
}
//Función que formatea un array de cadena a JSON
export function deTextoaJson(texto) {
  // Primero lo convertimos a un formato que pueda interpretarse como JSON
  const jsonFormatted = texto
    .replace(/^{|}$/g, '') // Eliminar llaves de inicio y fin
    .split(', ')
    .reduce((obj, pair) => {
      const [key, value] = pair.split('=');
      obj[key] = value !== undefined && value !== "" ? value : "";
      return obj;
    }, {});
  return jsonFormatted;

}